import React from 'react';
import { Breadcrumb, Typography } from 'antd';
import { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledBreadcrumb = styled(Breadcrumb)`
  @media (max-width: 575px) {
    ol li {
      margin-inline: 0;
    }

    h3 {
      font-size: 20px;
      margin: 0;
    }
  }
`;

export const BreadcrumbItem: React.FC<{ path?: string; title: string }> = ({ path, title }) => {
  const FormattedTitle: React.FC = () => <Typography.Title level={3}>{title}</Typography.Title>;

  return (
    <>
      {path ? (
        <Link to={path}>
          <FormattedTitle />
        </Link>
      ) : (
        <FormattedTitle />
      )}
    </>
  );
};

export const Breadcrumbs: React.FC<{ breadcrumbItems: BreadcrumbItemType[] }> = ({ breadcrumbItems }) => {
  return <StyledBreadcrumb separator={<Typography.Title level={3}>/</Typography.Title>} items={breadcrumbItems} />;
};
